import { Link } from "react-router-dom";

//primereact
import { BreadCrumb } from "primereact/breadcrumb";

const items = [
  {
    template: () => (
      <Link to={"/commission/launchCommission"} className="p-breadcrumb-link">
        Comissões
      </Link>
    ),
  },
];

const home = {
  template: () => (
    <Link to={"#"} className="p-breadcrumb-link">
      <i className="fa fa-home"></i>
    </Link>
  ),
};

export function LaunchCommissionHeader() {
  return (
    <div className="row">
      <div className="col-md-12">
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>
    </div>
  );
}
